import {
  IssueSeverity as IssueSeverityProto,
  IssueTarget as IssueTargetProto,
  ValidationIssue as ValidationIssueProto,
  ValidationIssueList as ValidationIssueListProto,
} from "../../../../gen/witbooking/backoffice/common/common_pb";
import { IssueSeverity, IssueTarget, ValidationIssue } from "../../domain/entities/ValidationIssue";
import { ExtraCategoryMapper } from "./ExtraCategoryMapper";

const severityFromProtoMap: Record<IssueSeverityProto, IssueSeverity> = {
  [IssueSeverityProto.ISSUE_SEVERITY_UNSPECIFIED]: IssueSeverity.UNSPECIFIED,
  [IssueSeverityProto.ISSUE_SEVERITY_BLOCKING]: IssueSeverity.BLOCKING,
  [IssueSeverityProto.ISSUE_SEVERITY_WARNING]: IssueSeverity.WARNING,
};

/** proto3 strings are never unset: an empty string means "not set". */
const optional = (value: string): string | undefined => value || undefined;

export class ValidationIssueMapper {
  static toDomain(proto: ValidationIssueProto): ValidationIssue {
    return ValidationIssue.of({
      code: proto.getCode(),
      messageKey: optional(proto.getMessageKey()),
      severity: severityFromProtoMap[proto.getSeverity()] ?? IssueSeverity.UNSPECIFIED,
      target: ValidationIssueMapper.targetToDomain(proto.getTarget()),
      params: Object.fromEntries(proto.getParamsMap().toArray()),
      defaultMessage: proto.getDefaultMessage(),
    });
  }

  static toDomainList(protos: ValidationIssueProto[]): ValidationIssue[] {
    return protos.map(ValidationIssueMapper.toDomain);
  }

  static fromBinaryList(bytes: Uint8Array): ValidationIssue[] {
    return ValidationIssueMapper.toDomainList(
      ValidationIssueListProto.deserializeBinary(bytes).getIssuesList()
    );
  }

  private static targetToDomain(proto: IssueTargetProto | undefined): IssueTarget {
    if (!proto) {
      return IssueTarget.none();
    }
    return IssueTarget.of({
      propertyTicker: optional(proto.getPropertyTicker()),
      accommodationId: optional(proto.getAccommodationId()),
      category: ExtraCategoryMapper.toDomain(proto.getCategory()),
      extraTicker: optional(proto.getExtraTicker()),
      field: optional(proto.getField()),
    });
  }
}
